import { Context, Controller } from '@hotwired/stimulus';

export default class DomAttributesController extends Controller {
  public static values = {
    target: String,
    attributeName: String,
    attributeValue: String,
  };

  private declare targetValue: string;
  private declare attributeNameValue: string;
  private declare attributeValueValue: string;

  private targetElement: HTMLElement | null;

  public constructor(context: Context) {
    super(context);

    this.targetElement = null;
  }

  private get matchingElements(): NodeListOf<HTMLElement> {
    const selector = [
      `[data-dom-attributes-target-value="${this.targetValue}"]`,
      `[data-dom-attributes-attribute-name-value="${this.attributeNameValue}"]`,
      `[data-dom-attributes-attribute-value-value="${this.attributeValueValue}"]`,
    ];

    return document.querySelectorAll(selector.join(''));
  }

  public connect(): void {
    this.targetElement =
      this.element.closest(this.targetValue) ||
      document.querySelector(this.targetValue);
  }

  public disconnect(): void {
    this.targetElement = null;
  }

  public onToggle(event: Event) {
    console.log(event);
    if (!this.targetElement) {
      return;
    }

    switch (this.attributeNameValue) {
      case 'classList': {
        const active = this.targetElement.classList.toggle(
          this.attributeValueValue,
        );

        this.matchingElements.forEach((toggle) => {
          toggle.setAttribute('aria-pressed', String(active));
        });
        break;
      }

      default: {
        throw new Error(
          `Unsupported attribute name: ${this.attributeNameValue}`,
        );
      }
    }
  }
}
